import {
  faArrowRightArrowLeft,
  faCircle,
  faMessage,
  faRobot,
  IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Issue_ActivityHistoryEvent_HistoryType } from "@protos/issues/v1/issues";

const icons: Record<Issue_ActivityHistoryEvent_HistoryType, IconDefinition> = {
  [Issue_ActivityHistoryEvent_HistoryType.TRIAGE]: faArrowRightArrowLeft,
  [Issue_ActivityHistoryEvent_HistoryType.STATUS]: faMessage,
  [Issue_ActivityHistoryEvent_HistoryType.AUTOTRIAGE]: faRobot,
  [Issue_ActivityHistoryEvent_HistoryType.AI_TAG]: faRobot,
  [Issue_ActivityHistoryEvent_HistoryType.UNSPECIFIED]: faMessage,
};
export const bulletEventThumbnail = (
  history_type: Issue_ActivityHistoryEvent_HistoryType
) => {
  return (
    <FontAwesomeIcon
      size="sm"
      color="var(--mantine-color-gray-8)"
      icon={icons[history_type] || faCircle}
      fixedWidth
    />
  );
};
